import { render, staticRenderFns } from "./RetakeTutor.vue?vue&type=template&id=31c90df2&scoped=true"
import script from "./RetakeTutor.vue?vue&type=script&lang=js"
export * from "./RetakeTutor.vue?vue&type=script&lang=js"
import style0 from "./RetakeTutor.vue?vue&type=style&index=0&id=31c90df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c90df2",
  null
  
)

export default component.exports